import { AppLanguage, getPreferredLanguage } from '../language';

export interface ShippingCalculatorI18nTemplate {
  ui: {
    pageTitle: string;
    pageSubtitle: string;
    sectionSelectProduct: string;
    actionMyProducts: string;
    dropdownEdit: string;
    dropdownCopy: string;
    dropdownDelete: string;
    actionAddProduct: string;
    resultTitleDomestic: string;
    resultTitleCrossBorder: string;
    routeCnUs: string;
    routeUsUs: string;
    footerUnsupportedChannel: string;
    footerIncludedSurcharge: string;
    actionShipNow: string;
    actionPriceDetails: string;
    cardDropshippingTitle: string;
    cardDropshippingSubtext: string;
    cardDropshippingFooter: string;
    drawerFullQuote: string;
    filterWarehouse: string;
    filterInternational: string;
    filterExpress: string;
    feeDetailsGuaranteed: string;
    feeDetailsSpecial: string;
    priceNotesTitle: string;
    priceNotesProductTitle: string;
    priceNotesProductFallback: string;
    priceNotesProductDescriptionTemplate: string;
    priceNotesMeasurementTitle: string;
    priceNotesMeasurementDescription: string;
    priceNotesBillingTitle: string;
    priceNotesBillingDescription: string;
    priceNotesFluctuationTitle: string;
    priceNotesFluctuationDescription: string;
    extraExpressConfigTitle: string;
    statusActive: string;
    loading: string;
    popupDeletePermissionDenied: string;
    popupDeleteFailed: string;
    popupCopyPermissionDenied: string;
    popupCopyFailed: string;
    popupQuoteFailed: string;
    productCopySuffix: string;
    pricePlaceholder: string;
    quoteDrawerBadge: string;
    quoteDrawerMinFreightPrefix: string;
    quoteDrawerMinFreightSuffix: string;
    quoteDrawerFilterCarrier: string;
    quoteDrawerFilterDelivery: string;
    quoteDrawerFilterService: string;
    quoteDrawerDeliveryAll: string;
    quoteDrawerDelivery1d: string;
    quoteDrawerDelivery3d: string;
    quoteDrawerDelivery7d: string;
    quoteDrawerServiceNone: string;
    quoteDrawerServiceInsurance: string;
    quoteDrawerServiceSignature: string;
    quoteDrawerServiceAdultSignature: string;
    quoteDrawerSectionZoneTable: string;
    quoteDrawerSectionSurchargeNotes: string;
    quoteDrawerCarrierFeeStandardsSuffix: string;
    quoteDrawerBasicPricing: string;
    quoteDrawerCommonSurcharges: string;
    quoteDrawerOversizeExceptions: string;
  };
  parser: {
    regionOther: string;
    regionWest: string;
    regionEast: string;
    unknownWarehouse: string;
    freightSea: string;
    supplierHaihaiExpress: string;
    supplierPlatformLabel: string;
    platformLabelOptionName: string;
    autoBestPriceShort: string;
    autoBestPriceOptionName: string;
    autoBestPriceCoverage: string;
    expressCoverageTemplate: string;
    logisticsTransferConnector: string;
    logisticsDeliverySuffix: string;
    logisticsDayUnit: string;
    logisticsBatchStartTemplate: string;
    fallbackWarehouseName: string;
    fallbackWarehouseZip: string;
    fallbackInternationalLogistics: string;
    fallbackOverseasExpress: string;
  };
  restriction: {
    gofoUnsupported: string;
    uniuniUnsupported: string;
    warehouseMatchPattern: string;
  };
  quote: {
    internal: {
      platformLabelOptionName: string;
      autoBestPriceShort: string;
      supplierHaihaiExpress: string;
      shippingTypeWarehouse: string;
      shippingTypeInternational: string;
      shippingTypeExpress: string;
      headMethodAir: string;
      headMethodSea: string;
      headLastMileTruck: string;
      headLastMileLand: string;
      unitPerTicket: string;
      unitPerKg: string;
      surchargeSensitiveKeyword: string;
    };
    common: {
      approxPrefix: string;
      rangeFromSuffix: string;
      noQuote: string;
      free: string;
      daySuffix: string;
      dayAboveSuffix: string;
      dayPerCubicMeter: string;
      perTicketUnit: string;
      perKgUnit: string;
      perLbUnit: string;
      monthlyPerPiece: string;
      hourly: string;
      perPiece: string;
      perShipment: string;
      warehouseDefaultName: string;
    };
    regular: {
      sectionInternational: string;
      sectionInbound: string;
      sectionOutbound: string;
      sectionExpress: string;
      sectionStorage: string;
      badgePerPieceHead: string;
      badgePerPieceInbound: string;
      badgePerPieceOutbound: string;
      badgePerPieceExpress: string;
      titleInternationalFee: string;
      defaultHeadDescription: string;
      inboundInventoryCheck: string;
      inboundUnloadFee: string;
      expressFee: string;
      expressNearestZone: string;
      expressFarthestZone: string;
      expressPickupService: string;
      expressPartnerDelivery: string;
      expressPlatformFree: string;
      expressTailDefaultNote: string;
      subtitleWithExpress: string;
      subtitleWithoutExpress: string;
    };
    special: {
      title: string;
      sectionInternational: string;
      sectionInbound: string;
      sectionOutbound: string;
      sectionStorage: string;
      sectionUnsoldDisposal: string;
      sectionOtherServices: string;
      badgePerTicket: string;
      badgeHourly: string;
      badgePerPiece: string;
      badgeMonthlyPerPiece: string;
      itemExportCustoms: string;
      itemImportCustomsSea: string;
      itemImportCustomsAir: string;
      itemInventoryCheck: string;
      itemPackagingFix: string;
      itemMergePackaging: string;
      itemReturnHandling: string;
      itemUnsoldBatchDisposal: string;
      itemQcRepair: string;
    };
  };
}

export const TEMPLATES: Record<AppLanguage, ShippingCalculatorI18nTemplate> = {
  zh: {
    ui: {
      pageTitle: '跨境物流智能计算器',
      pageSubtitle: '只需2步，快速找回多款物流方案及报价详情',
      sectionSelectProduct: '选择一种商品',
      actionMyProducts: '我的商品',
      dropdownEdit: '编辑',
      dropdownCopy: '复制',
      dropdownDelete: '删除',
      actionAddProduct: '添加商品',
      resultTitleDomestic: '多家快递公司的报价',
      resultTitleCrossBorder: '多种运输方式的成本',
      routeCnUs: '中国 - 美国',
      routeUsUs: '美国 - 美国',
      footerUnsupportedChannel: '暂不支持该渠道',
      footerIncludedSurcharge: '已包含附加费',
      actionShipNow: '立即发货',
      actionPriceDetails: '费用明细',
      cardDropshippingTitle: '海外仓一件代发',
      cardDropshippingSubtext: '出单后2天送达',
      cardDropshippingFooter: '包含国际物流、海外仓、海外快递',
      drawerFullQuote: '完整报价',
      filterWarehouse: '选择海外仓',
      filterInternational: '选择国际物流方式',
      filterExpress: '选择海外快递公司',
      feeDetailsGuaranteed: '费用明细 · 一定会产生的费用',
      feeDetailsSpecial: '费用明细 · 特殊情况下的额外费用',
      priceNotesTitle: '价格说明',
      priceNotesProductTitle: '商品属性',
      priceNotesProductFallback: '商品',
      priceNotesProductDescriptionTemplate: '我们根据以往经验，将该{categories}暂定为普通商品。实际以发货时清关公司的判定为准，价格将据实调整。',
      priceNotesMeasurementTitle: '计量规则',
      priceNotesMeasurementDescription: '以上费用均按实重与体积重取高计费，体积重系数为166。各环节物流服务商在接收商品后，均会复测尺寸与重量，价格将据实调整。',
      priceNotesBillingTitle: '计费规则',
      priceNotesBillingDescription: '国际物流环节设有最低起运量，若未达到要求将按最低起运量计费，单票超过1000磅可以享受额外优惠；海外快递价格包含可能产生的超规附加费，不包含旺季附加费，最远距离不包含偏远地区。',
      priceNotesFluctuationTitle: '价格波动',
      priceNotesFluctuationDescription: '一件代发价格受政策、淡旺季影响较大，以上费用基于试算时的行情，实际以发货当日为准。',
      extraExpressConfigTitle: '海外快递额外费用配置',
      statusActive: '启用',
      loading: '加载中...',
      popupDeletePermissionDenied: '您的账户等级不足。请联系客服升级至专业卖家以删除商品。',
      popupDeleteFailed: '删除失败，请重试',
      popupCopyPermissionDenied: '您的账户等级不足。请联系客服升级至专业卖家以复制商品。',
      popupCopyFailed: '复制失败，请重试',
      popupQuoteFailed: '报价失败，请检查商品尺寸重量后重试',
      productCopySuffix: '（副本）',
      pricePlaceholder: '--',
      quoteDrawerBadge: '海外快递',
      quoteDrawerMinFreightPrefix: '从',
      quoteDrawerMinFreightSuffix: '发货的最低运费',
      quoteDrawerFilterCarrier: '选择快递公司',
      quoteDrawerFilterDelivery: '选择快递时效',
      quoteDrawerFilterService: '选择快递增值服务',
      quoteDrawerDeliveryAll: '所有时效',
      quoteDrawerDelivery1d: '1天内',
      quoteDrawerDelivery3d: '3天内',
      quoteDrawerDelivery7d: '7天内',
      quoteDrawerServiceNone: '无增值服务',
      quoteDrawerServiceInsurance: '保险',
      quoteDrawerServiceSignature: '签名',
      quoteDrawerServiceAdultSignature: '成人签名',
      quoteDrawerSectionZoneTable: '区域报价表',
      quoteDrawerSectionSurchargeNotes: '附加费用说明',
      quoteDrawerCarrierFeeStandardsSuffix: '费用标准',
      quoteDrawerBasicPricing: '基础计费',
      quoteDrawerCommonSurcharges: '常遇附加费',
      quoteDrawerOversizeExceptions: '超规与异常',
    },
    parser: {
      regionOther: '其他',
      regionWest: '美西',
      regionEast: '美东',
      unknownWarehouse: '未知仓库',
      freightSea: '海运',
      supplierHaihaiExpress: '海海快递',
      supplierPlatformLabel: '平台面单',
      platformLabelOptionName: '从电商平台购买快递面单',
      autoBestPriceShort: '自动匹配价格最优',
      autoBestPriceOptionName: '自动匹配价格最优 · 3-7天',
      autoBestPriceCoverage: '可送达100%邮编',
      expressCoverageTemplate: '可送达{coverage}%邮编',
      logisticsTransferConnector: '转',
      logisticsDeliverySuffix: '派送',
      logisticsDayUnit: '天',
      logisticsBatchStartTemplate: '{minBatch}磅起运',
      fallbackWarehouseName: '海海美西仓',
      fallbackWarehouseZip: '91744',
      fallbackInternationalLogistics: '美西空运 · 快递 · 快速 · 6-8天',
      fallbackOverseasExpress: '自动匹配价格最优 · 2-5天',
    },
    restriction: {
      gofoUnsupported: '该商品超出GOFO尺寸/重量限制或所选仓库不支持',
      uniuniUnsupported: '该商品超出UniUni尺寸/重量限制或所选仓库不支持',
      warehouseMatchPattern: '美西2号仓|美东1号仓',
    },
    quote: {
      internal: {
        platformLabelOptionName: '从电商平台购买快递面单',
        autoBestPriceShort: '自动匹配价格最优',
        supplierHaihaiExpress: '海海快递',
        shippingTypeWarehouse: '海外仓',
        shippingTypeInternational: '国际物流',
        shippingTypeExpress: '海外快递',
        headMethodAir: '空运',
        headMethodSea: '海运',
        headLastMileTruck: '卡车',
        headLastMileLand: '陆运',
        unitPerTicket: '每票',
        unitPerKg: '每千克',
        surchargeSensitiveKeyword: '敏感',
      },
      common: {
        approxPrefix: '约 ',
        rangeFromSuffix: ' 起',
        noQuote: '暂无报价',
        free: '免费',
        daySuffix: '天',
        dayAboveSuffix: '天以上',
        dayPerCubicMeter: '每天/m³',
        perTicketUnit: '每票',
        perKgUnit: '千克',
        perLbUnit: '磅',
        monthlyPerPiece: '每月/件',
        hourly: '每小时',
        perPiece: '每件',
        perShipment: '每票',
        warehouseDefaultName: '海海海外仓',
      },
      regular: {
        sectionInternational: '国际物流',
        sectionInbound: '海外仓入库',
        sectionOutbound: '海外仓出库',
        sectionExpress: '海外快递',
        sectionStorage: '海外仓仓储',
        badgePerPieceHead: '每件 · 发出时扣款',
        badgePerPieceInbound: '每件 · 入库时扣款',
        badgePerPieceOutbound: '每件 · 出库时扣款',
        badgePerPieceExpress: '每件 · 出库时扣款',
        titleInternationalFee: '国际物流费',
        defaultHeadDescription: '双清包税',
        inboundInventoryCheck: '清点入库',
        inboundUnloadFee: '卸货费',
        expressFee: '海外快递费',
        expressNearestZone: '最近距离（Zone 1）',
        expressFarthestZone: '最远距离（Zone 8）',
        expressPickupService: '自提服务',
        expressPartnerDelivery: '合作物流商配送',
        expressPlatformFree: '免收平台面单自提费',
        expressTailDefaultNote: '尾程报价采用默认仓库渠道价。升级后可见专属尾程报价。',
        subtitleWithExpress: '30天内售出的单件物流成本',
        subtitleWithoutExpress: '30天内售出的单件物流成本 · 不含海外快递',
      },
      special: {
        title: '特殊情况下的额外费用',
        sectionInternational: '国际物流',
        sectionInbound: '海外仓入库',
        sectionOutbound: '海外仓出库',
        sectionStorage: '海外仓仓储',
        sectionUnsoldDisposal: '海外仓滞销处置',
        sectionOtherServices: '海外仓其他服务',
        badgePerTicket: '每票',
        badgeHourly: '每小时',
        badgePerPiece: '每件',
        badgeMonthlyPerPiece: '每月/件',
        itemExportCustoms: '出口国单独报关附加费',
        itemImportCustomsSea: '进口国单独清关附加费 · 海运',
        itemImportCustomsAir: '进口国单独清关附加费 · 空运',
        itemInventoryCheck: '逐件清点服务',
        itemPackagingFix: '不合规包装的整改服务',
        itemMergePackaging: '一票多件合并打包费',
        itemReturnHandling: '一件代发退货处理费',
        itemUnsoldBatchDisposal: '将滞销商品批量出库或销毁',
        itemQcRepair: '质检、维修等非标准化服务',
      },
    },
  },
  en: {
    ui: {
      pageTitle: 'Cross-border Logistics Calculator',
      pageSubtitle: 'Find logistics plans and pricing details in 2 quick steps.',
      sectionSelectProduct: 'Select a product',
      actionMyProducts: 'My products',
      dropdownEdit: 'Edit',
      dropdownCopy: 'Copy',
      dropdownDelete: 'Delete',
      actionAddProduct: 'Add product',
      resultTitleDomestic: 'Quotes from multiple carriers',
      resultTitleCrossBorder: 'Cost across shipping stages',
      routeCnUs: 'China - United States',
      routeUsUs: 'United States - United States',
      footerUnsupportedChannel: 'This channel is not available',
      footerIncludedSurcharge: 'Surcharges included',
      actionShipNow: 'Ship now',
      actionPriceDetails: 'Price details',
      cardDropshippingTitle: 'Overseas Warehouse Fulfillment',
      cardDropshippingSubtext: 'Delivered in as fast as 2 days',
      cardDropshippingFooter: 'Includes head-leg, warehouse, and last-mile services',
      drawerFullQuote: 'Full quote',
      filterWarehouse: 'Select warehouse',
      filterInternational: 'Select head-leg shipping',
      filterExpress: 'Select last-mile carrier',
      feeDetailsGuaranteed: 'Fee details · always charged',
      feeDetailsSpecial: 'Fee details · charged in special cases',
      priceNotesTitle: 'Pricing notes',
      priceNotesProductTitle: 'Product attributes',
      priceNotesProductFallback: 'product',
      priceNotesProductDescriptionTemplate: 'Based on prior experience, this {categories} is provisionally treated as a standard product. Final classification is determined by the customs clearance provider at shipping time, and pricing may be adjusted accordingly.',
      priceNotesMeasurementTitle: 'Measurement rules',
      priceNotesMeasurementDescription: 'All fees are charged by the greater of actual weight and dimensional weight (DIM factor 166). Service providers may re-measure dimensions and weight upon receipt, and pricing may be adjusted accordingly.',
      priceNotesBillingTitle: 'Billing rules',
      priceNotesBillingDescription: 'Head-leg shipping has a minimum launch quantity and will be billed at the minimum when not met; shipments above 1000 lb may receive additional discounts. Last-mile pricing includes potential oversize surcharges, excludes peak-season surcharges, and the farthest-zone quote excludes remote areas.',
      priceNotesFluctuationTitle: 'Price fluctuation',
      priceNotesFluctuationDescription: 'Fulfillment pricing is sensitive to policy and seasonal shifts. Estimates shown here are based on current market rates and final charges apply on shipment date.',
      extraExpressConfigTitle: 'Last-mile additional fee configuration',
      statusActive: 'Active',
      loading: 'Loading...',
      popupDeletePermissionDenied: 'Your account level is insufficient. Contact support to upgrade before deleting products.',
      popupDeleteFailed: 'Delete failed, please try again',
      popupCopyPermissionDenied: 'Your account level is insufficient. Contact support to upgrade before copying products.',
      popupCopyFailed: 'Copy failed, please try again',
      popupQuoteFailed: 'Quote failed. Please check the product dimensions and weight, then try again.',
      productCopySuffix: ' (Copy)',
      pricePlaceholder: '--',
      quoteDrawerBadge: 'Last-mile shipping',
      quoteDrawerMinFreightPrefix: 'Minimum freight from',
      quoteDrawerMinFreightSuffix: '',
      quoteDrawerFilterCarrier: 'Select carrier',
      quoteDrawerFilterDelivery: 'Select delivery speed',
      quoteDrawerFilterService: 'Select value-added services',
      quoteDrawerDeliveryAll: 'All speeds',
      quoteDrawerDelivery1d: 'Within 1 day',
      quoteDrawerDelivery3d: 'Within 3 days',
      quoteDrawerDelivery7d: 'Within 7 days',
      quoteDrawerServiceNone: 'No extra services',
      quoteDrawerServiceInsurance: 'Insurance',
      quoteDrawerServiceSignature: 'Signature',
      quoteDrawerServiceAdultSignature: 'Adult signature',
      quoteDrawerSectionZoneTable: 'Zone quotes',
      quoteDrawerSectionSurchargeNotes: 'Surcharge notes',
      quoteDrawerCarrierFeeStandardsSuffix: 'Fee standards',
      quoteDrawerBasicPricing: 'Base pricing',
      quoteDrawerCommonSurcharges: 'Common surcharges',
      quoteDrawerOversizeExceptions: 'Oversize and exceptions',
    },
    parser: {
      regionOther: 'Other',
      regionWest: 'US West',
      regionEast: 'US East',
      unknownWarehouse: 'Unknown warehouse',
      freightSea: 'Sea',
      supplierHaihaiExpress: 'HaiHai Express',
      supplierPlatformLabel: 'Platform Label',
      platformLabelOptionName: 'Buy shipping label from e-commerce platform',
      autoBestPriceShort: 'Best price auto match',
      autoBestPriceOptionName: 'Best price auto match · 3-7 days',
      autoBestPriceCoverage: 'Delivers to 100% ZIP codes',
      expressCoverageTemplate: 'Delivers to {coverage}% ZIP codes',
      logisticsTransferConnector: ' + ',
      logisticsDeliverySuffix: ' delivery',
      logisticsDayUnit: ' days',
      logisticsBatchStartTemplate: 'Starts at {minBatch} lb',
      fallbackWarehouseName: 'HaiHai US West Warehouse',
      fallbackWarehouseZip: '91744',
      fallbackInternationalLogistics: 'US West Air · Express · Fast · 6-8 days',
      fallbackOverseasExpress: 'Best price auto match · 2-5 days',
    },
    restriction: {
      gofoUnsupported: 'Package exceeds GOFO size/weight limits or selected warehouse is unsupported',
      uniuniUnsupported: 'Package exceeds UniUni size/weight limits or selected warehouse is unsupported',
      warehouseMatchPattern: '美西2号仓|美东1号仓',
    },
    quote: {
      internal: {
        platformLabelOptionName: '从电商平台购买快递面单',
        autoBestPriceShort: '自动匹配价格最优',
        supplierHaihaiExpress: '海海快递',
        shippingTypeWarehouse: '海外仓',
        shippingTypeInternational: '国际物流',
        shippingTypeExpress: '海外快递',
        headMethodAir: '空运',
        headMethodSea: '海运',
        headLastMileTruck: '卡车',
        headLastMileLand: '陆运',
        unitPerTicket: '每票',
        unitPerKg: '每千克',
        surchargeSensitiveKeyword: '敏感',
      },
      common: {
        approxPrefix: 'Approx ',
        rangeFromSuffix: '+',
        noQuote: 'No quote',
        free: 'Free',
        daySuffix: ' days',
        dayAboveSuffix: '+ days',
        dayPerCubicMeter: '/day/m³',
        perTicketUnit: 'per shipment',
        perKgUnit: "KG",
        perLbUnit: 'lb',
        monthlyPerPiece: 'per month / piece',
        hourly: 'per hour',
        perPiece: 'per piece',
        perShipment: 'per shipment',
        warehouseDefaultName: 'HaiHai Overseas Warehouse',
      },
      regular: {
        sectionInternational: 'Head-leg shipping',
        sectionInbound: 'Warehouse inbound',
        sectionOutbound: 'Warehouse outbound',
        sectionExpress: 'Last-mile shipping',
        sectionStorage: 'Warehouse storage',
        badgePerPieceHead: 'Per piece · charged at departure',
        badgePerPieceInbound: 'Per piece · charged at inbound',
        badgePerPieceOutbound: 'Per piece · charged at outbound',
        badgePerPieceExpress: 'Per piece · charged at outbound',
        titleInternationalFee: 'Head-leg shipping fee',
        defaultHeadDescription: 'Duty paid',
        inboundInventoryCheck: 'Inbound check-in',
        inboundUnloadFee: 'Unloading fee',
        expressFee: 'Last-mile fee',
        expressNearestZone: 'Nearest distance (Zone 1)',
        expressFarthestZone: 'Farthest distance (Zone 8)',
        expressPickupService: 'Self pickup',
        expressPartnerDelivery: 'Partner carrier delivery',
        expressPlatformFree: 'Platform-label pickup fee waived',
        expressTailDefaultNote: 'Last-mile quote uses default warehouse channel pricing. Upgrade to view your dedicated channel pricing.',
        subtitleWithExpress: 'Per-item logistics cost sold within 30 days',
        subtitleWithoutExpress: 'Per-item logistics cost sold within 30 days · excludes last-mile shipping',
      },
      special: {
        title: 'Additional fees in special scenarios',
        sectionInternational: 'Head-leg shipping',
        sectionInbound: 'Warehouse inbound',
        sectionOutbound: 'Warehouse outbound',
        sectionStorage: 'Warehouse storage',
        sectionUnsoldDisposal: 'Unsold inventory disposal',
        sectionOtherServices: 'Other warehouse services',
        badgePerTicket: 'per shipment',
        badgeHourly: 'per hour',
        badgePerPiece: 'per piece',
        badgeMonthlyPerPiece: 'per month / piece',
        itemExportCustoms: 'Export customs clearance surcharge',
        itemImportCustomsSea: 'Import customs surcharge · Sea',
        itemImportCustomsAir: 'Import customs surcharge · Air',
        itemInventoryCheck: 'Item-by-item inventory check',
        itemPackagingFix: 'Non-compliant packaging correction',
        itemMergePackaging: 'Multi-item consolidation packaging',
        itemReturnHandling: 'Fulfillment return handling',
        itemUnsoldBatchDisposal: 'Batch outbound or destruction for unsold inventory',
        itemQcRepair: 'Non-standard services (QC, repair, etc.)',
      },
    },
  },
};

export const SHIPPING_CALCULATOR_NAMESPACE = 'shippingCalculator';

export const SHIPPING_CALCULATOR_RESOURCE_KEY = 'template';

export const SHIPPING_CALCULATOR_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof SHIPPING_CALCULATOR_RESOURCE_KEY, ShippingCalculatorI18nTemplate>
> = {
  zh: {
    [SHIPPING_CALCULATOR_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [SHIPPING_CALCULATOR_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getShippingCalculatorTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): ShippingCalculatorI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;

export const formatWithTemplate = (
  template: string,
  values: Record<string, string | number>,
): string => {
  return Object.entries(values).reduce((result, [key, value]) => {
    return result.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value));
  }, template);
};
